<template>
    <div>
        <div v-if="!loaded" class="enqContent d-flex align-items-center">
            <strong>{{ __("Loading...") }}</strong>
            <div
                class="spinner-border ml-auto"
                role="status"
                aria-hidden="true"
            ></div>
        </div>

        <div v-else>
            <div v-if="!order && !disabled">
                <div class="partSearch">
                    <api-search
                        class="w-100"
                        :route="'enquiries/fragment/parts/searchParts'"
                        :disabled="disabled"
                        :autocomplete-css="'max-height: 454px;'"
                        :placeholder="'Search for Part'"
                    >
                        <template v-slot="row">
                            <div
                                class="dropdown-item d-flex"
                                :class="row.item.exact ? 'part-exact' : ''"
                            >
                                <div
                                    class="flex-grow-1 align-self-stretch btn-a"
                                    style="width: 50%"
                                    @click="partClick(row.item.ID, row.defocus)"
                                >
                                    <div class="pb-1">
                                        {{ formatPartName(row.item) }}
                                    </div>
                                    <div
                                        class="text-muted text-truncate"
                                        style="font-size: 9.5pt"
                                    >
                                        {{ formatPartDesc(row.item) }}
                                    </div>
                                </div>

                                <button
                                    class="align-self-stretch btn rounded-left-only py-1 mr-1 ml-3"
                                    :class="
                                        stockAvailable(
                                            row.item.stock,
                                            'new_qty'
                                        )
                                            ? 'btn-success'
                                            : 'btn-outline-secondary'
                                    "
                                    style="width: 8%"
                                    :disabled="
                                        !stockAvailable(
                                            row.item.stock,
                                            'new_qty'
                                        )
                                    "
                                    @click.stop.prevent="
                                        partClick(
                                            row.item.ID,
                                            row.defocus,
                                            row.item.stock,
                                            'new_qty',
                                            'new_price',
                                            1
                                        )
                                    "
                                >
                                    <div style="font-size: 9.5pt">
                                        <i class="fas fa-box"></i>
                                    </div>
                                    <div style="font-size: 8pt">
                                        {{ __("New") }}
                                    </div>
                                </button>

                                <button
                                    class="align-self-stretch btn rounded-0 py-1"
                                    :class="
                                        stockAvailable(
                                            row.item.stock,
                                            'used_qty'
                                        )
                                            ? 'btn-success'
                                            : 'btn-outline-secondary'
                                    "
                                    style="width: 8%"
                                    :disabled="
                                        !stockAvailable(
                                            row.item.stock,
                                            'used_qty'
                                        )
                                    "
                                    @click.stop.prevent="
                                        partClick(
                                            row.item.ID,
                                            row.defocus,
                                            row.item.stock,
                                            'used_qty',
                                            'used_price',
                                            2
                                        )
                                    "
                                >
                                    <div style="font-size: 9.5pt">
                                        <i class="fas fa-box-open"></i>
                                    </div>
                                    <div style="font-size: 8pt">
                                        {{ __("Used") }}
                                    </div>
                                </button>

                                <button
                                    class="align-self-stretch btn rounded-right-only py-1 ml-1"
                                    :class="
                                        stockAvailable(
                                            row.item.stock,
                                            'repair_price'
                                        )
                                            ? 'btn-success'
                                            : 'btn-outline-secondary'
                                    "
                                    style="width: 8%"
                                    :disabled="
                                        !stockAvailable(
                                            row.item.stock,
                                            'repair_price'
                                        )
                                    "
                                    @click.stop.prevent="
                                        partClick(
                                            row.item.ID,
                                            row.defocus,
                                            row.item.stock,
                                            'repair_price',
                                            'repair_price',
                                            4
                                        )
                                    "
                                >
                                    <div style="font-size: 9.5pt">
                                        <i class="fas fa-pallet"></i>
                                    </div>
                                    <div style="font-size: 8pt">
                                        {{ __("Repair") }}
                                    </div>
                                </button>
                            </div>
                        </template>
                        <template v-slot:noresults="row">
                            <div class="dropdown-item d-flex">
                                <a
                                    :href="addPartRoute + '/' + btoa(row.query)"
                                    target="_blank"
                                    class="pap"
                                    >{{ __("Submit a part to add") }}</a
                                >
                            </div>
                        </template>
                    </api-search>

                    <br />

                    <!-- <a :href="addPartRoute" target="_blank" class="pap">{{
                        __("Submit a part to add")
                    }}</a> -->
                </div>

                <hr />
            </div>

            <div class="partSearch" v-if="0 === parts.length">
                <div class="result">
                    {{ __("There are currently no parts on this enquiry.") }}
                </div>
            </div>

            <enq-part
                v-else
                v-for="(part, key) in parts"
                ref="parts"
                :key="part.ID"
                :index="key"
                :part="part"
                :disabled="disabled"
                :order="order"
                :currency="currency"
                :exchange-rates="exchangeRates"
                :conditions="conditions"
                :currencies="currencies"
                :financial-risk="isHighFinancialRisk(part)"
                :on-updated="onUpdated"
                :on-duplicated="onDuplicated"
                :on-deleted="onDeleted"
                :supplier-disabled="hasPO(part)"
                :focus="partFocus"
            ></enq-part>

            <hr v-if="hasFinancialRisk || !disabled" />

            <!-- financialRisk -->
            <div class="highFinancialRisk" v-if="hasFinancialRisk">
                <img
                    :src="iconPath + '/layout/financial-risk.png'"
                    :alt="__('High Financial Risk')"
                    :title="__('High Financial Risk')"
                />

                <p v-html="riskLine1"></p>
                <p v-html="riskLine2"></p>
                <p v-html="riskLine3"></p>

                <!-- <div v-if="financialRiskTotal > 0">
                    <p v-html="riskLine3"></p>
                </div> -->
            </div>

            <enq-portion-additional-costs
                :type="'customer'"
                :enquiry-id="enquiryId"
                :reasons="customerReasons"
                :currencies="currencies"
                :default-currency-id="enquiryCurrencyId"
                :disabled="disabled"
                :update-stats="updateStats"
                :is-order="isOrder"
            ></enq-portion-additional-costs>

            <enq-portion-additional-costs
                :type="'dax'"
                :enquiry-id="enquiryId"
                :reasons="daxReasons"
                :currencies="currencies"
                :default-currency-id="1"
                :disabled="!isOrder && disabled"
                :update-stats="updateStats"
                :is-order="isOrder"
            ></enq-portion-additional-costs>

            <div v-if="isOrder">
                <!-- deposits -->
                <enq-portion-additional-costs
                    :type="'deposits'"
                    :enquiry-id="enquiryId"
                    :reasons="depositReasons"
                    :currencies="currencies"
                    :default-currency-id="enquiryCurrencyId"
                    :disabled="disabled"
                    :update-stats="updateStats"
                    :is-order="isOrder"
                ></enq-portion-additional-costs>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EnqFragmentParts",

    props: {
        parts: {
            required: true,
            type: Array,
        },

        validPos: {
            required: true,
            type: Array,
        },

        enquiryId: {
            required: true,
            type: Number,
        },

        enquiryCurrencyId: {
            required: true,
            type: Number,
        },

        companyPaymentTermsId: {
            required: true,
            type: Number,
        },

        currency: {
            required: true,
            type: Object,
        },

        exchangeRates: {
            required: true,
            type: Object,
        },

        disabled: {
            required: true,
            type: Boolean,
        },

        order: {
            required: true,
            type: Boolean,
        },

        updateEnquiry: {
            required: true,
            type: Function,
        },

        updateStatuses: {
            required: true,
            type: Function,
        },

        updateStats: {
            required: true,
            type: Function,
        },

        isOrder: {
            required: true,
            type: Boolean,
        },

        iconPath: {
            required: true,
            type: String,
        },

        partFocus: {
            required: true,
            type: Boolean,
        },
    },

    data() {
        return {
            loaded: false,

            addPartRoute: "",

            conditions: [],
            daxReasons: [],
            customerReasons: [],
            depositReasons: [], // bit of a cop-out but who cares
            riskCharge: 0,

            financialRiskTotal: 0,
            hasFinancialRisk: false,
        };
    },

    created() {
        this.$on("child-total-updated", _.debounce(this.recalculateTotals, 50));
    },

    computed: {
        posBySupplier() {
            let out = {};

            this.validPos.forEach((po) => {
                out[po.supplierID] = true;
            });

            return out;
        },

        // https://github.com/vuejs/vue/issues/1186
        riskLine1() {
            return __(
                "One or more items on this enquiry are of a <strong>high financial risk</strong>. These parts are marked in red."
            );
        },

        riskLine2() {
            return __(
                "You (the trader), will be charged <strong>:riskCharge%</strong> of the total cost of each part that is of a high financial risk.",
                {
                    riskCharge: this.riskCharge,
                }
            );
        },

        riskLine3() {
            return __(
                "Including delivery, the total value of high risk parts on this enquiry is <strong>:currency:formattedFinancialRiskTotal</strong> and you will be charged <strong>:currency2:formattedFinancialRiskCut</strong>.",
                {
                    currency: DEFAULT_CURRENCY_SYMBOL,
                    formattedFinancialRiskTotal: number_format(
                        this.financialRiskTotal,
                        2
                    ),
                    currency2: DEFAULT_CURRENCY_SYMBOL,
                    formattedFinancialRiskCut: number_format(
                        (this.financialRiskTotal / 100) * this.riskCharge,
                        2
                    ),
                }
            );
        },
    },

    methods: {
        btoa(str) {
            // node is dumb
            return btoa(str);
        },

        stockAvailable(stock, column) {
            let count = 0;

            stock.forEach((row) => {
                count += row[column];
            });

            return count > 0;
        },

        hasPO(part) {
            return (
                (part.part_supplier &&
                    _.get(
                        this.posBySupplier,
                        part.part_supplier.supplierID,
                        false
                    )) ||
                false
            );
        },

        partClick(partID, callback, stock, columnCheck, column, condition) {
            let supplierID = null;
            let buyValue = null;

            // TODO: they probably want this reviewed if multiple suppliers get added...
            if (stock) {
                let good_stock = null;

                for (let i = 0; i < stock.length; i++) {
                    let row = stock[i];

                    if (row[columnCheck] > 0) {
                        good_stock = row;

                        break;
                    }
                }

                if (good_stock) {
                    supplierID = good_stock.supplier_id;
                    buyValue = good_stock[column] * STOCK_BUY_MULT;
                }
            }
            axios
                .post("/api/enquiries/fragment/parts/submit", {
                    enquiryID: this.enquiryId,
                    partID: partID,
                    supplierID: supplierID,
                    buyValue: buyValue,
                    conditionID: condition,
                })
                .then((response) => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        this.updateEnquiry(data.enquiry, true);
                        this.updateStatuses(data.statuses);
                    }
                })
                .catch((error) => {
                    console.error(error.response);

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                });

            console.log("running callback to clear");

            callback("");
        },

        onModified(route, key, params) {
            params.enquiryID = this.enquiryId;
            params.order = this.isOrder;
            params.partID = this.parts[key].ID;

            // $(':focus').blur();

            axios
                .post(route, params)
                .then((response) => {
                    // console.log(response);

                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        // console.log("parts did an enquiry update");

                        this.updateEnquiry(data.enquiry);
                        this.updateStatuses(data.statuses);
                    }
                })
                .catch((error) => {
                    console.error(error.response);

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                });
        },

        onUpdated(key, params) {
            this.onModified(
                "/api/enquiries/fragment/parts/update",
                key,
                params
            );
        },

        onDuplicated(key) {
            this.onModified("/api/enquiries/fragment/parts/copy", key, {});
        },

        onDeleted(key) {
            this.onModified("/api/enquiries/fragment/parts/delete", key, {});
        },

        recalculateTotals() {
            let value = 0;

            this.hasFinancialRisk = false;
            this.$refs.parts.forEach((part) => {
                // $exchangeRates->convert($part->currencyID, 1, $totalBuyValue);

                if (this.isHighFinancialRisk(part.part)) {
                    this.hasFinancialRisk = true;
                    let buy = part.buyTotalRaw;

                    if (0.0 === buy) {
                        return;
                    }

                    if (part.currencyID !== DEFAULT_CURRENCY_ID) {
                        buy *= this.exchangeRates[
                            part.part.currency.currency +
                                "to" +
                                DEFAULT_CURRENCY_CURRENCY
                        ];
                    }

                    value += buy;
                }
            });

            this.financialRiskTotal = value;
        },

        /**
         * High financial risk is when the supplier requires an up front payment and the customer is in some form of account.
         * Medium financial risk is when both parties are on an account or both parties pay up front.
         * Low financial risk is when the customer pays up front and the supplier is on an account.
         * However, we only want to know if something is high or not.
         *
         * Current payment terms are:
         * 1 - Proforma.
         * 2 - On receipt of invoice.
         * 3 > Some form of account.
         **/
        isHighFinancialRisk(part) {
            // No supplier yet, so no way to know
            if (!part.part_supplier || 0 === part.part_supplier.supplierID) {
                return false;
            }

            let supplierTerms = part.part_supplier.supplier.paymentTermsID;

            if (undefined === supplierTerms || supplierTerms <= 0) {
                return false;
            }

            let customerTerms = this.companyPaymentTermsId;

            // Customer is not on account, cannot be high risk
            if (customerTerms < 3) {
                return false;
            }

            /**
             * If the customer is on an account of '60 days nett monthly' (7) or '60 days from invoice date' (4) they are high financial
             * risk regardless of the supplier terms.
             **/
            if (4 === customerTerms || 7 === customerTerms) {
                return true;
            } else {
                return supplierTerms < 3;
            }
        },

        formatPartName(part) {
            let text = part.manufacturer.manufacturerName + " " + part.partNo;
            return text.slice(0, 45) + (text.length > 45 ? "..." : "");
        },

        formatPartDesc(part) {
            let text = part.description;
            return text.charAt(0).toUpperCase() + text.slice(1);
        },
    },

    mounted() {
        axios
            .post("/api/enquiries/fragment/parts/get", {
                enquiryID: this.enquiryId,
                order: this.isOrder,
            })
            .then((response) => {
                // console.log(response);

                let data = response.data;
                if (!data.success) {
                    $("#fail-alert")
                        .text(data.message || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                } else {
                    this.loaded = true;
                    this.addPartRoute = data.addPartRoute;
                    this.conditions = data.conditions;
                    this.currencies = data.currencies;
                    this.riskCharge = data.riskCharge;
                    this.daxReasons = data.daxReasons;
                    this.depositReasons = data.depositReasons;
                    this.customerReasons = data.customerReasons;
                }
            })
            .catch((error) => {
                console.error(error.response);

                $("#fail-alert")
                    .text(error.toString() || "Unknown error")
                    .slideDown(500)
                    .delay(5000)
                    .slideUp(500);
            });
    },
};
</script>
